import React, { useContext, useReducer, useEffect, useMemo, useRef } from "react";
import CRUD from "../../components/CRUD/CRUD";
import LocalizationContext from "../../utils/LocalizationContext";
import useStyles from "./CavitestFinishedStyles";
import t from "../../utils/translation";
import request from "../../utils/request";
import { getDist, getSession, getUserId } from "../../utils/sessionHandler";
import df from "../../utils/dateFormater";
import _ from "lodash";
import CircularProgress from "../../components/CircularProgress";
import Modal from "../../components/Modal";
import PageContentLoading from "../../components/PageContentLoading";
import { flatten, unflatten } from "flat";
import Progress from "../../components/Progress";
import Button from "../../components/Button";
import GroupedDetail from "../../components/GroupedDetail/GroupedDetail";
import reducer from "./CavitestFinishedReducer";

const isAspTheme = JSON.parse(localStorage.getItem("__dist"))?.themeFileName === "aspTheme";

const formatSelectObjectProd = (objectData, emptyText) => {
    return objectData.reduce(
        (objectsList, object) => {
            objectsList.push([object.id, object.description || object.toString, object.productModel]);
            return objectsList;
        },
        [[null, emptyText]]
    );
};

const initialState = {
    products: [],
    possibleResults: [],
    loadingContent: true,
    loadingData: false,
    pagination: { Page: 1, PageSize: 10 },
    requiredFields: [],
    data: [],
    detailObject: null,
    loadingDetail: false,
    formFields: [],
    detailFields: [],
    historical: {
        toHistoricalObject: null,
        toHistoricalLoading: false,
        toHistoricalMessage: {
            type: "none",
        },
    },
    groups: [
        { Description: t("ProductGroup"), position: 1, Index: 0, visible: true },
        { Description: t("IncubationGroup"), position: 0, Index: 1, visible: true },
        { Description: t("OtherGroup"), position: 2, Index: 2, visible: true },
    ],
    indexProductGroup: 0,
    indexIncubationGroup: 1,
    indexOtherGroup: 2,
};

const CavitestFinished = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const classes = useStyles();
    const locale = useContext(LocalizationContext);
    const CRUDRef = useRef(null);

    const baseObject = useMemo(
        () => ({
            UserLogged: getSession(),
        }),
        [locale]
    );

    const massiveBaseObject = useMemo(
        () => ({
            ReadCavitestMasive: {
                ReadIds: [],
                productId: null,
                loteProduct: "",
                bookNumber: "",
                pageNumber: "",
                reference: "",
                programNumber: "",
                notes: "",
            },
            UserLogged: getSession(),
        }),
        [locale]
    );

    const formFieldsDefinition = () => [
        {
            position: 0,
            groupIndex: state.indexProductGroup,
            label: t("ProductLabel", locale),
            propOnObject: "ReadingCavitest.productId",
            propOnMassiveObject: "ReadCavitestMasive.productId",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1225) ? true : false,
            type: "select",
            options: state.products,
        },
        {
            position: 1,
            groupIndex: state.indexProductGroup,
            label: t("LoteProductLabel", locale) || "Product Lot",
            propOnObject: "ReadingCavitest.loteProduct",
            propOnMassiveObject: "ReadCavitestMasive.loteProduct",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1235) ? true : false,
        },
        {
            position: 0,
            groupIndex: state.indexOtherGroup,
            label: t("BookNumberLabel", locale),
            propOnObject: "ReadingCavitest.bookNumber",
            propOnMassiveObject: "ReadCavitestMasive.bookNumber",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1285) ? true : false,
        },
        {
            position: 1,
            groupIndex: state.indexOtherGroup,
            label: t("PageNumberLabel", locale),
            propOnObject: "ReadingCavitest.pageNumber",
            propOnMassiveObject: "ReadCavitestMasive.pageNumber",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1295) ? true : false,
        },
        ...(!isAspTheme
            ? [
                  {
                      position: 2,
                      groupIndex: state.indexOtherGroup,
                      label: t("ReferenceSpan") || "Reference",
                      propOnObject: "ReadingCavitest.reference",
                      propOnMassiveObject: "ReadCavitestMasive.reference",
                      class: "col-12 col-md-6 px-0",
                      required: false,
                  },
              ]
            : []),
        {
            position: 3,
            groupIndex: state.indexOtherGroup,
            label: t("ProgramNumberLabel", locale) || "Used Program",
            propOnObject: "ReadingCavitest.programNumber",
            propOnMassiveObject: "ReadCavitestMasive.programNumber",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1297) ? true : false,
        },
        {
            position: 4,
            groupIndex: state.indexOtherGroup,
            label: t("NotesLabel", locale),
            propOnObject: "ReadingCavitest.notes",
            propOnMassiveObject: "ReadCavitestMasive.notes",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1345) ? true : false,
        },
    ];

    const detailFieldsDefinition = useMemo(
        () => [
            // Product group
            { label: t("ProductLabel", locale), name: "product.toString", position: 0, groupIndex: state.indexProductGroup },
            { label: t("LoteProductLabel", locale) || "Product Lot", name: "loteProduct", position: 1, groupIndex: state.indexProductGroup },
            // Incubation group
            { label: t("UserLabel", locale), name: "appUser.toString", position: 0, groupIndex: state.indexIncubationGroup },
            { label: t("SectorLabel", locale), name: "sector.toString", position: 1, groupIndex: state.indexIncubationGroup },
            { label: t("PositionNumberLabel", locale) || "Position Number", name: "positionNumber", position: 2, groupIndex: state.indexIncubationGroup },
            { label: t("TicketNumber", locale) || "Ticket Number", name: "ticketNumber", position: 3, groupIndex: state.indexIncubationGroup },
            { label: t("StartTimeLabel", locale) || "Starting Time", name: "startedTime", type: "dateTime", position: 4, groupIndex: state.indexIncubationGroup },
            { label: t("EndTimeLabel", locale) || "End Time", name: "resultDate", type: "dateTime", position: 5, groupIndex: state.indexIncubationGroup },
            { label: t("IncubatorLabel", locale) || "Incubator", name: "incubator.toString", position: 6, groupIndex: state.indexIncubationGroup },
            { label: t("ResultLabel", locale), name: "resultDescription", position: 7, groupIndex: state.indexIncubationGroup },
            // Other group
            { label: t("BookNumberLabel", locale), name: "bookNumber", position: 0, groupIndex: state.indexOtherGroup },
            { label: t("PageNumberLabel", locale), name: "pageNumber", position: 1, groupIndex: state.indexOtherGroup },
            ...(!isAspTheme
                ? [{ label: t("ReferenceSpan") || "Reference", name: "reference", position: 2, groupIndex: state.indexOtherGroup }]
                : []),
            { label: t("ProgramNumberLabel", locale) || "Used Program", name: "programNumber", position: 3, groupIndex: state.indexOtherGroup },
            { label: t("NotesLabel", locale), name: "notes", position: 4, groupIndex: state.indexOtherGroup },
        ],
        [locale]
    );

    const setupFormFields = () => {
        dispatch({
            type: "SET_FORM_FIELDS",
            payload: {
                formFields: formFieldsDefinition(),
                detailFields: detailFieldsDefinition,
            },
        });
    };

    useEffect(() => {
        Promise.all([
            request().get(`/api/Product/GetByDistributorEncrypted?distributorId=${getDist().id}`),
            request().get("/api/ReadingCavitest/GetPossibleResults"),
            request().get(`/api/Screen/GetRequiredFields?Screen=600`),
        ])
            .then(([productsData, possibleResultsData, requiredFields]) => {
                setTimeout(() => {
                    dispatch({
                        type: "SET_CONTENT",
                        payload: {
                            products: formatSelectObjectProd(productsData.data, t("ChooseAProductText", locale)),
                            possibleResults: possibleResultsData.data,
                            requiredFields: requiredFields.data,
                        },
                    });
                }, 250);
            })
            .catch((error) => console.log(error.response));
    }, [locale]);

    useEffect(() => {
        if (!state.loadingContent) {
            setupFormFields();
            updateData();
        }
    }, [state.loadingContent]);

    const getFinishedReadings = (
        Pagination = {
            Page: state.pagination.Page,
            PageSize: state.pagination.PageSize,
            OrderBy: null,
            OrderType: null,
        }
    ) => {
        dispatch({ type: "SET_PAGINATION", payload: { pagination: Pagination } });
        updateData();
    };

    const updateData = () => {
        dispatch({ type: "TOGGLE_LOADING_DATA" });
        request()
            .get(`/api/ReadingCavitest/getprovisional?UserLoggedId=${getUserId()}`)
            .then((response) => {
                dispatch({
                    type: "SET_DATA",
                    payload: {
                        data: response.data
                            .reduce((readingsList, reading) => {
                                readingsList.push({
                                    ...reading,
                                    startTimeFormatted: df(reading.startedTime, "dateTime"),
                                    endTimeFormatted: df(reading.resultDate, "dateTime"),
                                    incubatorName: reading.incubator?.toString || "",
                                });
                                return readingsList;
                            }, [])
                            .map((x) =>
                                _.mapKeys(x, (value, key) => {
                                    return "ReadingCavitest." + key;
                                })
                            ),
                    },
                });
                dispatch({ type: "TOGGLE_LOADING_DATA" });
            })
            .catch((error) => console.log(error.response));
    };

    const getDetail = (r) => {
        dispatch({
            type: "SET_DETAIL_OBJECT",
            payload: { detailObject: null, loadingDetail: true },
        });
        request()
            .get(`/api/ReadingCavitest/getdetail?Id=${r["ReadingCavitest.id"]}`)
            .then((response) => {
                setTimeout(() => {
                    const row = state.data.find((x) => x["ReadingCavitest.id"] === response.data.id);
                    if (row) row["ReadingCavitest.viewed"] = true;
                    dispatch({
                        type: "SET_DETAIL_OBJECT",
                        payload: {
                            detailObject: flatten(response.data),
                            data: state.data,
                            loadingDetail: false,
                        },
                    });
                }, 500);
            });
    };

    const toHistorical = (read) => {
        dispatch({
            type: "SET_HISTORICAL",
            payload: { toHistoricalLoading: true },
        });
        request()
            .post("/api/ReadingCavitest/toHistorical", {
                ...unflatten(read),
                UserLogged: getSession(),
            })
            .then((response) => {
                if (response.data.result === "ERRORS") {
                    setTimeout(() => {
                        dispatch({
                            type: "SET_HISTORICAL",
                            payload: {
                                toHistoricalLoading: false,
                                toHistoricalObject: false,
                                toHistoricalMessage: {
                                    type: "error",
                                    message: response.data.errors.map((e) => <p key={e}>{e}</p>),
                                },
                            },
                        });
                    }, 500);
                } else {
                    setTimeout(() => {
                        dispatch({
                            type: "SET_HISTORICAL",
                            payload: {
                                toHistoricalLoading: false,
                                toHistoricalObject: false,
                                toHistoricalMessage: {
                                    type: "success",
                                    message: response.data.message,
                                },
                            },
                        });
                        CRUDRef.current.api({ type: "clearSelected" });
                        updateData();
                    }, 500);
                    setTimeout(() => {
                        dispatch({
                            type: "SET_HISTORICAL",
                            payload: { toHistoricalMessage: { type: "none" } },
                        });
                    }, 3000);
                }
            })
            .catch((error) => {
                dispatch({
                    type: "SET_HISTORICAL",
                    payload: {
                        toHistoricalLoading: false,
                        toHistoricalObject: false,
                        toHistoricalMessage: {
                            type: "error",
                            message: error.response?.data?.message || error.response?.data,
                        },
                    },
                });
            });
    };

    const toHistoricalMassive = (readings, ids) => {
        dispatch({
            type: "SET_HISTORICAL",
            payload: { toHistoricalLoading: true },
        });
        request()
            .post("/api/ReadingCavitest/masiveToHistorical", {
                ReadCavitestMasive: { ReadIds: ids, ...unflatten(readings[0]) },
                UserLogged: getSession(),
            })
            .then((response) => {
                if (response.data.result === "ERRORS") {
                    setTimeout(() => {
                        dispatch({
                            type: "SET_HISTORICAL",
                            payload: {
                                toHistoricalLoading: false,
                                toHistoricalObject: false,
                                toHistoricalMessage: {
                                    type: "error",
                                    message: response.data.errors.map((e) => <p key={e}>{e}</p>),
                                },
                            },
                        });
                    }, 500);
                } else {
                    setTimeout(() => {
                        dispatch({
                            type: "SET_HISTORICAL",
                            payload: {
                                toHistoricalLoading: false,
                                toHistoricalObject: false,
                                toHistoricalMessage: {
                                    type: "success",
                                    message: response.data.message,
                                },
                            },
                        });
                        CRUDRef.current.api({ type: "clearSelected" });
                        updateData();
                    }, 500);
                    setTimeout(() => {
                        dispatch({
                            type: "SET_HISTORICAL",
                            payload: { toHistoricalMessage: { type: "none" } },
                        });
                    }, 3000);
                }
            })
            .catch((error) => {
                dispatch({
                    type: "SET_HISTORICAL",
                    payload: {
                        toHistoricalLoading: false,
                        toHistoricalObject: false,
                        toHistoricalMessage: {
                            type: "error",
                            message: error.response?.data?.message || error.response?.data,
                        },
                    },
                });
            });
    };

    if (state.loadingContent) return <PageContentLoading />;

    return (
        <div>
            <CRUD
                ref={CRUDRef}
                newOption={false}
                detailOption={false}
                deleteOption={false}
                viewedMark={true}
                multiSelect={true}
                massiveActions={[
                    {
                        caption: t("MultipleToHistoricalButton") || "Move to Historical",
                        action: (a, b) => {
                            dispatch({
                                type: "SET_HISTORICAL",
                                payload: {
                                    toHistoricalObject: {
                                        object: a,
                                        action: () => toHistoricalMassive(a, b),
                                    },
                                },
                            });
                        },
                    },
                ]}
                onEditClick={() => {
                    setupFormFields();
                }}
                onEditMassiveButtonClick={() => {
                    setupFormFields();
                }}
                resultStatus={true}
                data={state.data}
                order={{ dir: "desc", orderBy: "ReadingCavitest.readNumber" }}
                updateData={() => getFinishedReadings(state.pagination)}
                loadingData={state.loadingData}
                url={"/api/ReadingCavitest"}
                massiveURL={"/api/ReadingCavitest/masiveModify"}
                title={t("CavitestTitle", locale) || "Cavitest"}
                tableHeader={t("CavitestProTitle", locale) || "Cavitest Finished"}
                tableActions={[
                    {
                        icon: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
                        tooltip: t("DetailTooltip"),
                        action: getDetail,
                    },
                    {
                        icon: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z",
                        tooltip: t("ToHistoricalTooltip") || "Move to Historical",
                        action: (r) => {
                            dispatch({
                                type: "SET_HISTORICAL",
                                payload: {
                                    toHistoricalObject: {
                                        object: r,
                                        action: () => toHistorical(r),
                                    },
                                },
                            });
                        },
                    },
                ]}
                columns={[
                    "ReadingCavitest.readNumber",
                    "ReadingCavitest.positionNumber",
                    ...(!isAspTheme ? ["ReadingCavitest.reference"] : []),
                    "ReadingCavitest.startTimeFormatted",
                    "ReadingCavitest.endTimeFormatted",
                    "ReadingCavitest.resultDescription",
                    "ReadingCavitest.ticketNumber",
                    "ReadingCavitest.incubatorName",
                ]}
                headers={[
                    t("ReadNumberLabel", locale),
                    t("PositionNumberLabel", locale) || "Position Number",
                    ...(!isAspTheme ? [t("ReferenceSpan")] : []),
                    t("StartTimeLabel", locale) || "Starting Time",
                    t("EndTimeLabel", locale) || "End Time",
                    t("ResultLabel", locale),
                    t("TicketNumber", locale) || "Ticket Number",
                    t("IncubatorLabel", locale) || "Incubator",
                ]}
                idField={"ReadingCavitest.id"}
                splitButtonExtraOptions={[
                    {
                        text: t("ConfirmAndSave") || "Confirm and Save",
                        onClickOption: undefined,
                        disabled: false,
                        moveToSaved: true,
                        useCommonFunction: true,
                    },
                ]}
                grouped={state.groups}
                useFieldMap={false}
                formFields={state.formFields}
                baseObject={baseObject}
                massiveBaseObject={massiveBaseObject}
                method={"put"}
            />

            {/* Detail Modal */}
            {(state.loadingDetail || state.detailObject) && (
                <Modal
                    header={
                        <div className={classes.header}>
                            <div className={classes.headerText}>{`${t("CavitestTitle", locale) || "Cavitest"} ${
                                state.detailObject ? `(${state.detailObject.readNumber})` : ""
                            }`}</div>
                            <span
                                className={classes.modalCloseButton}
                                onClick={() =>
                                    dispatch({
                                        type: "SET_DETAIL_OBJECT",
                                        payload: { detailObject: null },
                                    })
                                }
                            >
                                <svg viewBox="0 0 24 24">
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </span>
                        </div>
                    }
                    closeModal={() =>
                        dispatch({
                            type: "SET_DETAIL_OBJECT",
                            payload: { detailObject: null },
                        })
                    }
                    responsive
                >
                    {!state.detailObject && (
                        <div className={classes.detailLoading}>
                            <CircularProgress />
                        </div>
                    )}
                    {state.detailObject && (
                        <GroupedDetail groups={state.groups} detailFields={state.detailFields} detailObject={state.detailObject} />
                    )}
                </Modal>
            )}

            {/* To Historical Confirmation Modal */}
            {state.historical.toHistoricalObject && (
                <Modal
                    closeModal={() =>
                        dispatch({
                            type: "SET_HISTORICAL",
                            payload: { toHistoricalObject: null },
                        })
                    }
                    header={
                        <React.Fragment>
                            <div className={classes.header}>
                                <span className={classes.headerText}>
                                    {t("ToHistoricalHeader", locale) || "Move to Historical"}{" "}
                                    {state.historical.toHistoricalObject.object.length > 0
                                        ? "(" +
                                          state.historical.toHistoricalObject.object.reduce((name, item, index) => {
                                              return (
                                                  name +
                                                  item["ReadingCavitest.toString"] +
                                                  (index === state.historical.toHistoricalObject.object.length - 1 ? "" : ", ")
                                              );
                                          }, "") +
                                          ")"
                                        : "(" + state.historical.toHistoricalObject.object["ReadingCavitest.toString"] + ")"}
                                </span>
                            </div>
                            <Progress active={state.historical.toHistoricalLoading} />
                        </React.Fragment>
                    }
                    footer={
                        <div className={classes.footerAction}>
                            <Button
                                caption={t("CancelButton") || "Cancel"}
                                onClick={() =>
                                    dispatch({
                                        type: "SET_HISTORICAL",
                                        payload: {
                                            toHistoricalObject: null,
                                            toHistoricalLoading: false,
                                        },
                                    })
                                }
                                variant={"text"}
                                color={"error"}
                                disabled={state.historical.toHistoricalLoading}
                            />
                            <Button
                                caption={t("ConfirmButton") || "Confirm"}
                                variant={"text"}
                                onClick={state.historical.toHistoricalObject.action}
                                disabled={state.historical.toHistoricalLoading}
                            />
                        </div>
                    }
                >
                    <div className={"container-fluid"}>
                        <div className={"row"}>
                            <div className={"col-12"} style={{ textAlign: "center" }}>
                                {t("ToHistoricalConfirmationText", locale) || "Are you sure you want to move this reading to historical?"}
                            </div>
                        </div>
                    </div>
                </Modal>
            )}

            {/* Error Modal */}
            {state.historical.toHistoricalMessage.type === "error" && (
                <Modal
                    header={
                        <div className={classes.header}>
                            <div className={classes.headerText}></div>
                            <span
                                className={classes.modalCloseButton}
                                onClick={() =>
                                    dispatch({
                                        type: "SET_HISTORICAL",
                                        payload: { toHistoricalMessage: { type: "none" } },
                                    })
                                }
                            >
                                <svg viewBox="0 0 24 24">
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </span>
                        </div>
                    }
                    closeModal={() =>
                        dispatch({
                            type: "SET_HISTORICAL",
                            payload: { toHistoricalMessage: { type: "none" } },
                        })
                    }
                >
                    <div className={`alert alert-danger`} role="alert">
                        {state.historical.toHistoricalMessage.message}
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default CavitestFinished;
